webpackJsonp([1],{

/***/ 1009:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1029:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_Login__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_AddressBook__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_AddressBookList__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_ContactDetailView__ = __webpack_require__(1178);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{
  path: '/login',
  component: __WEBPACK_IMPORTED_MODULE_2__components_views_Login__["a" /* default */],
  meta: {
    requiresAuth: false
  }
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_3__components_views_AddressBook__["a" /* default */],
  meta: {
    requiresAuth: true
  },
  children: [{
    path: '',
    name: 'Home',
    redirect: '/contacts',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'contacts',
    name: 'Contacts',
    component: __WEBPACK_IMPORTED_MODULE_4__components_views_AddressBookList__["a" /* default */],
    meta: {
      requiresAuth: true
    },
    children: [{
      path: ':id',
      name: 'ContactDetail',
      component: __WEBPACK_IMPORTED_MODULE_5__components_views_ContactDetailView__["a" /* default */],
      meta: {
        requiresAuth: true
      }
    }]
  }]
}];

function createRouter(config) {
  var STORAGE_TOKEN_ID = config.STORAGE_TOKEN_ID;

  var isUserAuthenticated = function isUserAuthenticated() {
    return !!localStorage.getItem(STORAGE_TOKEN_ID);
  };

  var authGuard = function authGuard(to, from, next) {
    if (to.matched.some(function (record) {
      return record.meta.requiresAuth;
    })) {
      // this route requires auth, check if logged in
      // if not, redirect to login page.
      if (!isUserAuthenticated()) {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        });
      } else {
        next();
      }
    } else {
      next(); // make sure to always call next()!
    }
  };

  var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: routes,
    mode: 'history',
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      }
      if (to.hash) {
        return { selector: to.hash };
      }
      return { x: 0, y: 0 };
    }
  });

  router.beforeEach(authGuard);

  return router;
}

/***/ }),

/***/ 1031:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(487);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb27f5c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(1035);
function injectStyle (ssrContext) {
  __webpack_require__(1032)
}
var normalizeComponent = __webpack_require__(32)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cb27f5c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb27f5c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1032:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1033:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1034:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout',{attrs:{"id":"main-layout"}},[_c('div',[_vm._t("default")],2),_vm._v(" "),(_vm.showFooter)?_c('div',{staticClass:"footer",style:({ textAlign: 'center' })},[_c('span',[_vm._v(" CDTM ©2019  ")]),_vm._v(" "),_c('span',[_vm._v(" | ")]),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.appVersion))]),_vm._v(" "),_c('span',[_vm._v(" | ")]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.cdtm.de/contact/","target":"_blank"}},[_vm._v("Impressum")]),_vm._v(" "),_c('span',[_vm._v(" | ")]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.cdtm.de/legal/","target":"_blank"}},[_vm._v("Data Privacy")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1035:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',{attrs:{"showFooter":true}},[_c('div',{staticClass:"login-view"},[_c('div',{staticClass:"form-container"},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/logo_cdtm.png","width":"150px","alt":""}}),_vm._v(" "),_c('h1',[_vm._v("Contacts")]),_vm._v(" "),_c('a-form',{staticClass:"login-form",attrs:{"id":"view-login","form":_vm.form},on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit($event)}}},[_c('p',[_vm._v("\n          Contacts is a read-only address book for Centerling's data that supports offline storage.\n          You can add it to your home screen.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          You can login using your CDTM email address (firstname.lastname@cdtm.de).\n        ")]),_vm._v(" "),_c('a-form-item',[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
              'email',
              { rules: [{ required: true, message: 'Please input your email!' }] }
            ]),expression:"[\n              'email',\n              { rules: [{ required: true, message: 'Please input your email!' }] }\n            ]"}],attrs:{"placeholder":"Email"}},[_c('a-icon',{staticStyle:{"color":"rgba(0,0,0,.25)"},attrs:{"slot":"prefix","type":"user"},slot:"prefix"})],1)],1),_vm._v(" "),_c('a-form-item',[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
              'password',
              { rules: [{ required: true, message: 'Please input your Password!' }] }
            ]),expression:"[\n              'password',\n              { rules: [{ required: true, message: 'Please input your Password!' }] }\n            ]"}],attrs:{"type":"password","placeholder":"Password"}},[_c('a-icon',{staticStyle:{"color":"rgba(0,0,0,.25)"},attrs:{"slot":"prefix","type":"lock"},slot:"prefix"})],1)],1),_vm._v(" "),_c('div',{staticClass:"error"},[(_vm.error)?_c('span',[_vm._v("\n            "+_vm._s(_vm.error)+"\n          ")]):_vm._e(),_vm._v("\n           \n        ")]),_vm._v(" "),_c('a-form-item',[_c('a-button',{staticClass:"login-form-button",attrs:{"type":"primary","html-type":"submit"}},[_vm._v("\n            Log in\n          ")]),_vm._v("\n          Or "),_c('a',{attrs:{"href":"https://home.cdtm.de/index.php/login","target":"_blank"}},[_vm._v("reset password")])],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1036:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressBook_vue__ = __webpack_require__(490);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_231163b7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressBook_vue__ = __webpack_require__(1038);
function injectStyle (ssrContext) {
  __webpack_require__(1037)
}
var normalizeComponent = __webpack_require__(32)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressBook_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_231163b7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressBook_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1037:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1038:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',{attrs:{"showFooter":false}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1039:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressBookList_vue__ = __webpack_require__(491);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_533e3bea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressBookList_vue__ = __webpack_require__(1177);
function injectStyle (ssrContext) {
  __webpack_require__(1040)
}
var normalizeComponent = __webpack_require__(32)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-533e3bea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressBookList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_533e3bea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressBookList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1040:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1041:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionBar_vue__ = __webpack_require__(492);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37ae71c4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionBar_vue__ = __webpack_require__(1146);
function injectStyle (ssrContext) {
  __webpack_require__(1042)
  __webpack_require__(1043)
}
var normalizeComponent = __webpack_require__(32)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-37ae71c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37ae71c4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1042:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1043:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-bar"},[_c('div',{staticClass:"action-container"},[_c('div',{staticClass:"content-left"},[_c('a-dropdown',{attrs:{"trigger":['click']}},[_c('h2',[_vm._v("\n            "+_vm._s(_vm.title)+"\n            "),_c('a-icon',{staticStyle:{"font-size":"18px"},attrs:{"type":"down"}})],1),_vm._v(" "),_c('a-menu',{attrs:{"slot":"overlay"},slot:"overlay"},[_c('a-menu-item',{staticClass:"sort-order-menu-item"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.selectSort('id', -1)}}},[_c('span',[_vm._v("Created At")]),_vm._v(" "),_c('span',[_c('a-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSelectedSortOrder('id')),expression:"isSelectedSortOrder('id')"}],attrs:{"type":"check"}})],1)])]),_vm._v(" "),_c('a-menu-item',{staticClass:"sort-order-menu-item"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.selectSort('firstname', 1)}}},[_c('span',[_vm._v("First Name")]),_vm._v(" "),_c('span',[_c('a-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSelectedSortOrder('firstname')),expression:"isSelectedSortOrder('firstname')"}],attrs:{"type":"check"}})],1)])]),_vm._v(" "),_c('a-menu-item',{staticClass:"sort-order-menu-item"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.selectSort('lastname', 1)}}},[_c('span',[_vm._v("Last Name")]),_vm._v(" "),_c('span',[_c('a-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSelectedSortOrder('lastname')),expression:"isSelectedSortOrder('lastname')"}],attrs:{"type":"check"}})],1)])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"content-right"},[_c('a',{staticClass:"logout-button",on:{"click":_vm.logout}},[_vm._v("Logout")])])]),_vm._v(" "),_c('div',{staticClass:"content-container"},[_c('div',{staticClass:"content"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"meta"},[_vm._v(_vm._s(_vm.appVersion)+" | "+_vm._s(_vm.lastUpdate))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchBar_vue__ = __webpack_require__(528);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f043f61c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchBar_vue__ = __webpack_require__(1149);
function injectStyle (ssrContext) {
  __webpack_require__(1148)
}
var normalizeComponent = __webpack_require__(32)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f043f61c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f043f61c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1148:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-bar"},[_c('a-input',{ref:"searchBarInput",attrs:{"placeholder":"Search"},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}},[_c('a-icon',{attrs:{"slot":"prefix","type":"search"},slot:"prefix"}),_vm._v(" "),(_vm.query)?_c('a-icon',{attrs:{"slot":"suffix","type":"close-circle"},on:{"click":_vm.emitEmpty},slot:"suffix"}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactList_vue__ = __webpack_require__(529);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69ed6c5e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactList_vue__ = __webpack_require__(1154);
function injectStyle (ssrContext) {
  __webpack_require__(1151)
  __webpack_require__(1152)
}
var normalizeComponent = __webpack_require__(32)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69ed6c5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69ed6c5e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1151:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1152:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-list"},[_c('vue-data-loading',{attrs:{"loading":_vm.isLoading,"listens":['pull-down']},on:{"pull-down":_vm.refresh}},[_c('div',{attrs:{"slot":"pull-down-before"},slot:"pull-down-before"},[_vm._v("Pull to refresh")]),_vm._v(" "),_c('div',{attrs:{"slot":"pull-down-ready"},slot:"pull-down-ready"},[_vm._v("Pull to refresh")]),_vm._v(" "),_c('div',{attrs:{"slot":"pull-down-loading"},slot:"pull-down-loading"},[_vm._v("Loading ...")]),_vm._v(" "),_c('div',{attrs:{"slot":"completed"},slot:"completed"},[_vm._v("Up to date :)")]),_vm._v(" "),_vm._l((_vm.contacts),function(item){return _c('div',{key:item.id,staticClass:"contact-list-item",on:{"click":function($event){return _vm.select(item)}}},[_c('div',{staticClass:"avatar-container"},[(item.thumbnailUrl)?_c('a-avatar',{attrs:{"src":item.thumbnailUrl}}):_vm._e(),_vm._v(" "),(!item.thumbnailUrl)?_c('a-avatar',{attrs:{"icon":"user"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"text-container"},[_c('div',{staticClass:"name"},[_vm._v("\n          "+_vm._s(item.firstname)+" "+_vm._s(item.lastname)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"cohort"},[_vm._v("\n          "+_vm._s(item.cohort || ' ')+"\n        ")])])])})],2),_vm._v(" "),_c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(_vm.visibilityChanged),expression:"visibilityChanged"}],staticClass:"showMoreContainer"},[_c('a-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoadMoreButton),expression:"showLoadMoreButton"}],attrs:{"type":"dashed"},on:{"click":_vm.showMore}},[_vm._v("Load More")])],1),_vm._v(" "),(!_vm.contacts || _vm.contacts.length == 0)?_c('div',_vm._l((20),function(index){return _c('div',{key:index},[_c('a-skeleton',{staticClass:"contact-list-item skeleton",attrs:{"active":"","avatar":"","title":""}})],1)}),0):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1155:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-detail"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"action-container"},[_c('div',{staticClass:"content-left"},[_c('a',{on:{"click":_vm.navigateBack}},[_c('a-icon',{attrs:{"type":"left"}}),_vm._v("Contacts\n          ")],1)]),_vm._v(" "),_c('div',{staticClass:"content-right"},[_c('a',{staticClass:"download-button",on:{"click":_vm.download}},[_c('a-icon',{attrs:{"type":"download"}}),_vm._v("\n              Download\n            ")],1)])]),_vm._v(" "),_c('div',{staticClass:"contact-overview"},[_c('div',{staticClass:"avatar-container"},[(_vm.contact.thumbnailUrl)?_c('a-avatar',{attrs:{"src":_vm.contact.thumbnailUrl,"size":90}}):_vm._e(),_vm._v(" "),(!_vm.contact.thumbnailUrl)?_c('a-avatar',{attrs:{"icon":"user","size":90}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"text-container"},[_c('div',{staticClass:"name"},[_vm._v("\n            "+_vm._s(_vm.contact.firstname)+" "+_vm._s(_vm.contact.lastname)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"cohort"},[_vm._v("\n            "+_vm._s(_vm.contact.cohort || ' ')+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"buttons"},[(_vm.contact.homePhone)?_c('a',{attrs:{"href":'tel: ' + _vm.contact.homePhone}},[_c('a-button',{attrs:{"type":"primary","shape":"circle","icon":"phone"}})],1):_vm._e(),_vm._v(" "),(_vm.contact.workEmail)?_c('a',{on:{"click":function($event){return _vm.openMailLink(_vm.contact.workEmail)}}},[_c('a-button',{attrs:{"type":"primary","shape":"circle","icon":"mail"}})],1):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"section"},[_c('div',{staticClass:"section-title"},[_vm._v("General")]),_vm._v(" "),_c('div',{staticClass:"entry"},[_c('div',{staticClass:"entry-label"},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"entry-value"},[_vm._v("\n        "+_vm._s(_vm.contact.firstname)+"\n        "+_vm._s(_vm.contact.middlename)+"\n        "+_vm._s(_vm.contact.lastname)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"entry"},[_c('div',{staticClass:"entry-label"},[_vm._v("Gender")]),_vm._v(" "),_c('div',{staticClass:"entry-value"},[_vm._v("\n        "+_vm._s(_vm.contact.gender)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"entry"},[_c('div',{staticClass:"entry-label"},[_vm._v("Nationality")]),_vm._v(" "),_c('div',{staticClass:"entry-value"},[_vm._v("\n        "+_vm._s(_vm.contact.nationality)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"entry"},[_c('div',{staticClass:"entry-label"},[_vm._v("birthday")]),_vm._v(" "),_c('div',{staticClass:"entry-value"},[_vm._v("\n        "+_vm._s(_vm.birthdayString)+"\n      ")])])]),_vm._v(" "),(_vm.contact)?_c('div',{staticClass:"section contact-info-container"},[_c('div',{staticClass:"section-title"},[_vm._v("\n      Contact\n    ")]),_vm._v(" "),_c('div',{staticClass:"entry"},[_c('div',{staticClass:"entry-label"},[_vm._v("Phone")]),_vm._v(" "),_c('div',{staticClass:"entry-value"},[(_vm.contact.homePhone)?_c('a',{attrs:{"href":'tel: ' + _vm.contact.homePhone}},[_vm._v("\n          "+_vm._s(_vm.contact.homePhone)+"\n        ")]):_c('span',[_vm._v("-")]),_vm._v("\n         \n      ")])]),_vm._v(" "),_c('div',{staticClass:"entry"},[_c('div',{staticClass:"entry-label"},[_vm._v("Phone (Work)")]),_vm._v(" "),_c('div',{staticClass:"entry-value"},[(_vm.contact.workPhone)?_c('a',{attrs:{"href":'tel: ' + _vm.contact.workPhone}},[_vm._v("\n          "+_vm._s(_vm.contact.workPhone)+"\n        ")]):_c('span',[_vm._v("-")]),_vm._v("\n         \n      ")])]),_vm._v(" "),_c('div',{staticClass:"entry"},[_c('div',{staticClass:"entry-label"},[_vm._v("CDTM Email")]),_vm._v(" "),_c('div',{staticClass:"entry-value"},[(_vm.contact.workEmail)?_c('a',{on:{"click":function($event){return _vm.openMailLink(_vm.contact.workEmail)}}},[_vm._v("\n          "+_vm._s(_vm.contact.workEmail)+"\n        ")]):_c('span',[_vm._v("-")]),_vm._v("\n         \n      ")])]),_vm._v(" "),_c('div',{staticClass:"entry"},[_c('div',{staticClass:"entry-label"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"entry-value"},[(_vm.contact.email)?_c('a',{on:{"click":function($event){return _vm.openMailLink(_vm.contact.email)}}},[_vm._v("\n          "+_vm._s(_vm.contact.email)+"\n        ")]):_c('span',[_vm._v("-")]),_vm._v("\n         \n      ")])])]):_vm._e(),_vm._v(" "),(_vm.contact.address)?_c('div',{staticClass:"section address-container"},[_c('div',{staticClass:"section-title"},[_vm._v("\n      Address\n    ")]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":'http://maps.google.com/maps?q=' + _vm.contact.address.street + ', ' + _vm.contact.address.zip + ' ' + _vm.contact.address.city + ' ' + _vm.contact.address.country}},[_c('div',[_vm._v(_vm._s(_vm.contact.address.street))]),_vm._v(" "),(_vm.contact.address.info)?_c('div',[_vm._v(_vm._s(_vm.contact.address.info))]):_vm._e(),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.contact.address.zip)+" "+_vm._s(_vm.contact.address.city))]),_vm._v(" "),(_vm.contact.address.region)?_c('div',[_vm._v(_vm._s(_vm.contact.address.region))]):_vm._e(),_vm._v(" "),(_vm.contact.address.country)?_c('div',[_vm._v(_vm._s(_vm.contact.address.country))]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.contact.emergencyContact)?_c('div',{staticClass:"section emergency-contact-container"},[_c('div',{staticClass:"section-title"},[_vm._v("\n      Emergency Contact\n    ")]),_vm._v(" "),_c('div',{staticClass:"entry"},[_c('div',{staticClass:"entry-label"},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"entry-value"},[(_vm.contact.emergencyContact.name)?_c('span',[_vm._v("\n          "+_vm._s(_vm.contact.emergencyContact.name)+" \n        ")]):_c('span',[_vm._v("-")]),_vm._v(" "),(_vm.contact.emergencyContact.affiliation)?_c('span',[_vm._v(" \n          ("+_vm._s(_vm.contact.emergencyContact.affiliation)+")\n        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"entry"},[_c('div',{staticClass:"entry-label"},[_vm._v("Phone")]),_vm._v(" "),_c('div',{staticClass:"entry-value"},[(_vm.contact.emergencyContact.phone)?_c('a',{attrs:{"href":'tel: ' + _vm.contact.emergencyContact.phone}},[_vm._v("\n          "+_vm._s(_vm.contact.emergencyContact.phone)+"\n        ")]):_c('span',[_vm._v("-")]),_vm._v("\n         \n      ")])]),_vm._v(" "),_c('div',{staticClass:"entry"},[_c('div',{staticClass:"entry-label"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"entry-value"},[(_vm.contact.emergencyContact.email)?_c('a',{on:{"click":function($event){return _vm.openMailLink(_vm.contact.emergencyContact.email)}}},[_vm._v("\n          "+_vm._s(_vm.contact.emergencyContact.email)+"\n        ")]):_c('span',[_vm._v("-")]),_vm._v("\n         \n      ")])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"address-book-list-view"}},[_c('a-row',[_c('a-col',{staticClass:"list-container",attrs:{"md":8,"xs":_vm.columnWidthSearchBar}},[_c('action-bar',{staticClass:"search-container",attrs:{"title":"Contacts"}},[_c('search-bar')],1),_vm._v(" "),_c('div',{staticClass:"contact-list-container"},[_c('contact-list')],1)],1),_vm._v(" "),_c('a-col',{attrs:{"md":16,"xs":_vm.columnWidthContactDetail}},[_c('router-view',[_c('div',{staticStyle:{"background":"white","height":"100vh","width":"100%"}})])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactDetailView_vue__ = __webpack_require__(532);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6acfa100_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactDetailView_vue__ = __webpack_require__(1180);
function injectStyle (ssrContext) {
  __webpack_require__(1179)
}
var normalizeComponent = __webpack_require__(32)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6acfa100"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactDetailView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6acfa100_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactDetailView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1179:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-detail-view"},[(_vm.contact)?_c('contact-detail',{attrs:{"contact":_vm.contact}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns__);











__WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* default */]);

function createStore(config, axios) {
  var APPLICATION_VERSION = config.APPLICATION_VERSION;
  var STORAGE_TOKEN_ID = config.STORAGE_TOKEN_ID;
  var STORAGE_PERSIST_ID = config.STORAGE_PERSIST_ID;
  var CAMPUS_API_HOST = config.CAMPUS_API_HOST;
  var CAMPUS_API_KEY = config.CAMPUS_API_KEY;
  var CAMPUS_AUTH_KEY = null;

  var makeUrl = function makeUrl(route) {
    return [CAMPUS_API_HOST, route].join('/');
  };

  var makeHeaders = function makeHeaders() {
    var authorization = ['ApiKey ' + CAMPUS_API_KEY];
    if (CAMPUS_AUTH_KEY && CAMPUS_AUTH_KEY.token) {
      authorization.push('Bearer ' + CAMPUS_AUTH_KEY.token);
    }
    return {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': authorization.join(', ')
      }
    };
  };

  var get = function get(route) {
    return axios.get(makeUrl(route), makeHeaders());
  };

  var post = function post(route, payload) {
    return axios.post(makeUrl(route), payload, makeHeaders());
  };

  var persistState = function persistState(state) {
    var jsonState = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(state);
    localStorage.setItem(STORAGE_PERSIST_ID, jsonState);
  };

  var restoreState = function restoreState(state) {
    var jsonState = localStorage.getItem(STORAGE_PERSIST_ID);
    if (jsonState) {
      var persistedState = JSON.parse(jsonState);
      state.user = persistedState.user;
      state.contacts = persistedState.contacts;
      state.lastUpdated = persistedState.lastUpdated;
      state.query = persistedState.query;
      state.sortOrder = persistedState.sortOrder;
    }
  };

  var destroyState = function destroyState() {
    localStorage.removeItem(STORAGE_PERSIST_ID);
  };

  var sortContacts = function sortContacts(contacts, sortByProperty) {
    var unsortedContacts = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(contacts)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        if (contacts[key]) {
          unsortedContacts.push(contacts[key]);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    if (!sortByProperty || !sortByProperty.property) {
      return unsortedContacts;
    }

    var sortedContacts = unsortedContacts.sort(function (a, b) {
      var propA = a[sortByProperty.property];
      var propB = b[sortByProperty.property];

      var NUMBER_TYPE = 'number';
      if (!(typeof propA === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(propA)) === NUMBER_TYPE) {
        propA = String(propA).toUpperCase();
        propB = String(propB).toUpperCase();
      }

      if (propA < propB) {
        return -1 * sortByProperty.direction;
      }
      if (propA > propB) {
        return 1 * sortByProperty.direction;
      }
      return 0;
    });

    return sortedContacts;
  };

  var filterContacts = function filterContacts(contacts, query) {
    var isPlainObject = function isPlainObject(object) {
      return Object.prototype.toString.call(object) === '[object Object]';
    };
    var objectMatchesQuery = function objectMatchesQuery(object, query, depth) {
      if (!query) {
        return true;
      }
      if (isPlainObject(object) && depth > 0) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(object)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var key = _step2.value;

            if (objectMatchesQuery(object[key], query, depth - 1)) {
              return true;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        return false;
      } else {
        return ('' + object).indexOf(query) >= 0;
      }
    };

    var filteredContacts = [];
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(contacts), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var contact = _step3.value;

        if (objectMatchesQuery(contact, query, 1)) {
          filteredContacts.push(contact);
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    return filteredContacts;
  };

  var store = new __WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* default */].Store({
    strict: true,

    state: {
      initialized: false,
      forceLogout: false,
      loading: false,
      user: null,
      query: null,
      sortOrder: {
        property: 'lastname',
        direction: 1
      },
      contacts: {},
      lastUpdated: '1970-01-01'
    },

    getters: {
      user: function user(state) {
        return state.user;
      },
      initialized: function initialized(state) {
        return state.initialized;
      },
      forceLogout: function forceLogout(state) {
        return state.forceLogout;
      },
      getSortOrder: function getSortOrder(state) {
        return state.sortOrder;
      },
      contacts: function contacts(state) {
        var sortedContacts = sortContacts(state.contacts, state.sortOrder);
        return filterContacts(sortedContacts, state.query);
      },
      getContactById: function getContactById(state) {
        return function (id) {
          return state.contacts[id];
        };
      },
      getLastUpdated: function getLastUpdated(state) {
        return state.lastUpdated;
      },
      getApplicationVersion: function getApplicationVersion() {
        return APPLICATION_VERSION;
      },
      getIsLoading: function getIsLoading(state) {
        return state.loading;
      }
    },

    actions: {
      init: function init(_ref) {
        var _this = this;

        var commit = _ref.commit,
            dispatch = _ref.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
          var token;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  // Implement this root action in modules

                  // Initial loading procedure
                  // 1. Get the token from the local storage
                  token = localStorage.getItem(STORAGE_TOKEN_ID);

                  token = token ? JSON.parse(token) : null;
                  commit('setToken', token);

                  if (!(CAMPUS_AUTH_KEY && CAMPUS_AUTH_KEY.valid_until && Object(__WEBPACK_IMPORTED_MODULE_8_date_fns__["isPast"])(new Date(CAMPUS_AUTH_KEY.valid_until)))) {
                    _context.next = 6;
                    break;
                  }

                  _context.next = 6;
                  return dispatch('logout');

                case 6:

                  // 2. Restore State from local storage
                  commit('initializeState');

                  // 3. Unlock the application and allow the router to redirect
                  commit('setInitialized');
                  _context.prev = 8;
                  _context.next = 11;
                  return dispatch('fetchCurrentUser');

                case 11:
                  _context.next = 13;
                  return dispatch('updateContactList');

                case 13:
                  _context.next = 17;
                  break;

                case 15:
                  _context.prev = 15;
                  _context.t0 = _context['catch'](8);

                case 17:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this, [[8, 15]]);
        }))();
      },
      fetchCurrentUser: function fetchCurrentUser(_ref2) {
        var _this2 = this;

        var commit = _ref2.commit,
            dispatch = _ref2.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
          var _ref3, data;

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  _context2.next = 3;
                  return get('x/api/auth/user');

                case 3:
                  _ref3 = _context2.sent;
                  data = _ref3.data;

                  if (!(!data || !data.email)) {
                    _context2.next = 7;
                    break;
                  }

                  throw new Error();

                case 7:

                  commit('setUser', data);
                  _context2.next = 14;
                  break;

                case 10:
                  _context2.prev = 10;
                  _context2.t0 = _context2['catch'](0);

                  // only revoke token if a 403 error was returned
                  if (_context2.t0.response && _context2.t0.response.status === 403) {
                    commit('setToken', null);
                    commit('setUser', null);
                    dispatch('logout');
                  }

                  throw new Error('Couldn\'t fetch current user!');

                case 14:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2, [[0, 10]]);
        }))();
      },
      login: function login(_ref4, payload) {
        var _this3 = this;

        var commit = _ref4.commit,
            dispatch = _ref4.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
          var _ref5, data;

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.prev = 0;
                  _context3.next = 3;
                  return post('x/api/auth', payload);

                case 3:
                  _ref5 = _context3.sent;
                  data = _ref5.data;

                  if (!(!data || !data.token)) {
                    _context3.next = 7;
                    break;
                  }

                  throw new Error();

                case 7:

                  commit('setToken', data);
                  _context3.next = 15;
                  break;

                case 10:
                  _context3.prev = 10;
                  _context3.t0 = _context3['catch'](0);

                  commit('setToken', null);
                  commit('setUser', null);
                  throw new Error('Login Failed. Invalid credentials.');

                case 15:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this3, [[0, 10]]);
        }))();
      },
      logout: function logout(_ref6) {
        var _this4 = this;

        var commit = _ref6.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.prev = 0;
                  _context4.next = 3;
                  return post('x/api/auth/logout');

                case 3:

                  commit('setToken', null);
                  commit('setUser', null);
                  commit('setForceLogout');
                  destroyState();
                  _context4.next = 15;
                  break;

                case 9:
                  _context4.prev = 9;
                  _context4.t0 = _context4['catch'](0);

                  commit('setToken', null);
                  commit('setUser', null);
                  commit('setForceLogout');
                  destroyState();

                case 15:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _callee4, _this4, [[0, 9]]);
        }))();
      },
      updateContactList: function updateContactList(_ref7) {
        var _this5 = this;

        var state = _ref7.state,
            commit = _ref7.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
          var lastUpdate, _ref8, data;

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.prev = 0;

                  commit('setIsLoading', true);
                  lastUpdate = Object(__WEBPACK_IMPORTED_MODULE_8_date_fns__["format"])(new Date(), 'YYYY-MM-DD HH:mm:ss');
                  _context5.next = 5;
                  return get('x/api/addressbook?after=' + state.lastUpdated);

                case 5:
                  _ref8 = _context5.sent;
                  data = _ref8.data;


                  commit('setContacts', data);
                  commit('setLastUpdated', lastUpdate);
                  commit('setIsLoading', false);
                  _context5.next = 16;
                  break;

                case 12:
                  _context5.prev = 12;
                  _context5.t0 = _context5['catch'](0);

                  commit('setIsLoading', false);
                  throw new Error('Couldn\'t update contact list.');

                case 16:
                case 'end':
                  return _context5.stop();
              }
            }
          }, _callee5, _this5, [[0, 12]]);
        }))();
      }
    },

    mutations: {
      setToken: function setToken(state, token) {
        if (!token) {
          CAMPUS_AUTH_KEY = null;
          localStorage.removeItem(STORAGE_TOKEN_ID);
        } else {
          CAMPUS_AUTH_KEY = token;
          localStorage.setItem(STORAGE_TOKEN_ID, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(token));
        }
      },
      setUser: function setUser(state, user) {
        state.user = user;
      },
      initializeState: function initializeState(state) {
        restoreState(state);
      },
      setInitialized: function setInitialized(state) {
        state.initialized = true;
      },
      setForceLogout: function setForceLogout(state) {
        state.forceLogout = true;
      },
      setContacts: function setContacts(state, contacts) {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(contacts), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var contact = _step4.value;

            state.contacts[contact.id] = contact;
          }
          // force rerender
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(state.contacts, state.contacts);
      },
      setLastUpdated: function setLastUpdated(state, lastUpdated) {
        state.lastUpdated = lastUpdated;
        persistState(state);
      },
      setSortOrder: function setSortOrder(state, sortOrder) {
        state.sortOrder = sortOrder;
        persistState(state);
      },
      setQuery: function setQuery(state, query) {
        state.query = query;
      },
      setIsLoading: function setIsLoading(state, loading) {
        state.loading = loading;
      }
    },

    modules: {}
  });

  // Webpack HRM
  if (false) {
    module.hot.accept([
      // './user'
    ], function () {
      store.hotUpdate({
        modules: {
          // user: require('./user').default
        }
      });
    });
  }

  return store;
}

/***/ }),

/***/ 223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  watch: {
    performLogout: function performLogout(newValue) {
      if (newValue) {
        this.$router.push('/login');
      }
    }
  },
  computed: {
    initialized: function initialized() {
      return this.$store.getters.initialized;
    },
    performLogout: function performLogout() {
      return this.initialized && this.$store.getters.forceLogout;
    }
  }
});

/***/ }),

/***/ 487:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_MainLayout_vue__ = __webpack_require__(488);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainLayout: __WEBPACK_IMPORTED_MODULE_2__components_layouts_MainLayout_vue__["a" /* default */]
  },
  data: function data() {
    return {
      error: null
    };
  },
  beforeCreate: function beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  mounted: function mounted() {
    if (this.user) {
      var path = this.$route.query.redirect || '/';
      this.$router.push(path);
    }
  },

  watch: {
    user: function user(newValue) {
      if (newValue) {
        var path = this.$route.query.redirect || '/';
        this.$router.push(path);
      }
    }
  },
  computed: {
    user: function user() {
      return this.$store.getters.user;
    }
  },
  methods: {
    handleSubmit: function handleSubmit(e) {
      var _this = this;

      this.form.validateFields(function (err, values) {
        if (!err) {
          _this.attemptLogin(values);
        }
      });
    },
    attemptLogin: function attemptLogin(values) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this2.$store.dispatch('login', values);

              case 3:
                _context.next = 5;
                return _this2.$store.dispatch('fetchCurrentUser');

              case 5:
                _context.next = 7;
                return _this2.$store.dispatch('updateContactList');

              case 7:
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                _this2.error = _context.t0;

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 9]]);
      }))();
    }
  }
});

/***/ }),

/***/ 488:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainLayout_vue__ = __webpack_require__(489);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b99cef60_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainLayout_vue__ = __webpack_require__(1034);
function injectStyle (ssrContext) {
  __webpack_require__(1033)
}
var normalizeComponent = __webpack_require__(32)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b99cef60_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 489:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['showFooter'],
  computed: {
    appVersion: function appVersion() {
      return 'Version ' + this.$store.getters.getApplicationVersion;
    }
  }
});

/***/ }),

/***/ 490:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_MainLayout_vue__ = __webpack_require__(488);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MainLayout: __WEBPACK_IMPORTED_MODULE_0__components_layouts_MainLayout_vue__["a" /* default */]
  }
});

/***/ }),

/***/ 491:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ActionBar__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SearchBar__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ContactList__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ContactDetail__ = __webpack_require__(530);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ActionBar: __WEBPACK_IMPORTED_MODULE_0__components_ActionBar__["a" /* default */],
    SearchBar: __WEBPACK_IMPORTED_MODULE_1__components_SearchBar__["a" /* default */],
    ContactList: __WEBPACK_IMPORTED_MODULE_2__components_ContactList__["a" /* default */],
    ContactDetail: __WEBPACK_IMPORTED_MODULE_3__components_ContactDetail__["a" /* default */]
  },
  data: function data() {
    return {
      isCreateNewTeamDrawerVisible: false,
      query: null
    };
  },
  mounted: function mounted() {
    this.$store.dispatch('updateContactList');
  },

  computed: {
    id: function id() {
      return this.$route.params.id;
    },
    columnWidthSearchBar: function columnWidthSearchBar() {
      if (this.id) {
        return 0;
      }
      return 24;
    },
    columnWidthContactDetail: function columnWidthContactDetail() {
      if (this.id) {
        return 24;
      }
      return 0;
    }
  }
});

/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    selectedSortOrder: function selectedSortOrder() {
      return this.$store.getters.getSortOrder;
    },
    isLoading: function isLoading() {
      return this.$store.getters.getIsLoading;
    },
    appVersion: function appVersion() {
      return 'Version ' + this.$store.getters.getApplicationVersion;
    },
    lastUpdate: function lastUpdate() {
      if (this.isLoading) {
        return 'Syncing ...';
      }

      var lastUpdate = this.$store.getters.getLastUpdated;
      if (!lastUpdate) {
        return 'Last Sync: ' + 'n/a';
      }
      return 'Last Sync: ' + Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["distanceInWordsToNow"])(Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["parse"])(lastUpdate), { addSuffix: true });
    }
  },
  methods: {
    logout: function logout() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$store.dispatch('logout');

              case 3:
                _this.$router.push('/login');
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](0);

                _this.$router.push('/login');

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 6]]);
      }))();
    },
    selectSort: function selectSort(property, direction) {
      this.$store.commit('setSortOrder', {
        property: property,
        direction: direction
      });
    },
    isSelectedSortOrder: function isSelectedSortOrder(property) {
      return this.selectedSortOrder && this.selectedSortOrder.property === property;
    }
  }

});

/***/ }),

/***/ 528:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      query: ''
    };
  },

  watch: {
    query: function query(newValue) {
      this.$store.commit('setQuery', this.query);
    }
  },
  methods: {
    emitEmpty: function emitEmpty() {
      this.$refs.searchBarInput.focus();
      this.query = '';
    }
  }
});

/***/ }),

/***/ 529:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_data_loading__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_data_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_data_loading__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VueDataLoading: __WEBPACK_IMPORTED_MODULE_2_vue_data_loading___default.a
  },
  data: function data() {
    return {
      sliceIndex: 50,
      loading: false
    };
  },

  computed: {
    isLoading: function isLoading() {
      return this.$store.getters.getIsLoading;
    },
    allContacts: function allContacts() {
      return this.$store.getters.contacts;
    },
    contacts: function contacts() {
      return this.allContacts.slice(0, this.sliceIndex);
    },
    showLoadMoreButton: function showLoadMoreButton() {
      return this.sliceIndex < this.allContacts.length;
    }
  },
  methods: {
    select: function select(contact) {
      this.$router.push('/contacts/' + contact.id);
    },
    refresh: function refresh() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$store.dispatch('updateContactList');

              case 3:
                _context.next = 7;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context['catch'](0);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 5]]);
      }))();
    },
    visibilityChanged: function visibilityChanged(isVisible, entry) {
      if (isVisible) {
        this.showMore();
      }
    },
    showMore: function showMore() {
      this.sliceIndex += 100;
    }
  }

});

/***/ }),

/***/ 530:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactDetail_vue__ = __webpack_require__(531);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d016969_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactDetail_vue__ = __webpack_require__(1176);
function injectStyle (ssrContext) {
  __webpack_require__(1155)
}
var normalizeComponent = __webpack_require__(32)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d016969"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d016969_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vcard_generator__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vcard_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vcard_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_file_saver__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contact: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      profilePictureDataUri: null
    };
  },
  mounted: function mounted() {
    // doesn't work because of CORS
    // this.getProfilePictureDataUri((error, result) => {
    //   if (!error) {
    //     this.profilePictureDataUri = result
    //   }
    //   this.profilePictureDataUri = null
    // })
  },

  watch: {
    contact: function contact() {
      // doesn't work because of CORS
      // this.getProfilePictureDataUri((error, result) => {
      //   if (!error) {
      //     this.profilePictureDataUri = result
      //   }
      //   this.profilePictureDataUri = null
      // })
    }
  },
  computed: {
    birthday: function birthday() {
      if (!this.contact.birthday) {
        return null;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["parse"])(this.contact.birthday);
    },
    birthdayString: function birthdayString() {
      if (!this.birthday) {
        return '-';
      }

      return this.birthday.toLocaleDateString();
    },
    vCardBirthday: function vCardBirthday() {
      if (!this.birthday) {
        return null;
      }

      return {
        year: this.birthday.getFullYear(),
        month: this.birthday.getMonth() + 1,
        day: this.birthday.getDate()
      };
    },
    vCardPhotos: function vCardPhotos() {
      if (this.profilePictureDataUri) {
        return [{
          type: 'home',
          dataUri: this.profilePictureDataUri
        }];
      } else {
        return [{
          type: 'home',
          dataUri: this.contact.thumbnailUrl
        }];
      }
    },
    vcardContent: function vcardContent() {
      return __WEBPACK_IMPORTED_MODULE_1_vcard_generator___default.a.generate({
        name: {
          familyName: this.contact.lastname,
          givenName: this.contact.firstname,
          middleName: this.contact.middlename,
          prefix: this.contact.gender === 'male' ? 'Mr.' : 'Ms.'
        },
        works: [{
          organization: 'CDTM',
          title: this.contact.cohort,
          role: 'Student'
        }],
        emails: [{
          type: 'work',
          text: this.contact.workEmail
        }, {
          type: 'home',
          text: this.contact.email
        }],
        phones: [{
          type: 'home',
          text: this.contact.homePhone
        }, {
          type: 'work',
          text: this.contact.workPhone
        }],
        addresses: [{
          type: 'home',
          street: this.contact.address && this.contact.address.street,
          locality: this.contact.address && this.contact.address.city,
          region: this.contact.address && this.contact.address.region,
          info: this.contact.address && this.contact.address.info,
          code: this.contact.address && this.contact.address.zip,
          country: this.contact.address && this.contact.address.country
        }],
        urls: [{
          type: 'personal',
          uri: this.contact.url
        }, {
          type: 'cdtm',
          uri: this.contact.workUrl
        }],

        photos: this.vCardPhotos,
        birthday: this.vCardBirthday,
        gender: {
          sex: this.contact.gender
        }
      });
    }
  },
  methods: {
    navigateBack: function navigateBack() {
      this.$router.push('/contacts');
    },
    parse: function parse(val) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["parse"])(val);
    },
    openMailLink: function openMailLink(mail) {
      window.open('mailto:' + mail);
    },
    openPhoneLink: function openPhoneLink(phone) {
      window.open('tel:' + phone, '_system');
    },
    getProfilePictureDataUri: function getProfilePictureDataUri(callback) {
      if (!this.contact.thumbnailUrl) {
        return callback(null, null);
      }

      fetch(this.contact.thumbnailUrl).then(function (r) {
        return r.blob();
      }).then(function (blob) {
        var reader = new FileReader();
        reader.onload = function () {
          var b64 = reader.result.replace(/^data:.+;base64,/, '');
          callback(null, b64.slice(0, 20) + '...' + b64.slice(-20));
        };
        reader.readAsDataURL(blob);
      }).catch(function (error) {
        callback(error, null);
        throw error;
      });
    },
    download: function download() {
      var blob = new File([String(this.vcardContent)], { type: 'application/octet-stream' });
      Object(__WEBPACK_IMPORTED_MODULE_2_file_saver__["saveAs"])(blob, this.contact.lastname + '.vcard');
    }
  }
});

/***/ }),

/***/ 532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ContactDetail__ = __webpack_require__(530);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ContactDetail: __WEBPACK_IMPORTED_MODULE_0__components_ContactDetail__["a" /* default */]
  },
  computed: {
    id: function id() {
      return this.$route.params.id;
    },
    contact: function contact() {
      return this.$store.getters.getContactById(this.id);
    }
  }
});

/***/ }),

/***/ 533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_vue__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ant_design_vue__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ant_design_vue_dist_antd_less__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ant_design_vue_dist_antd_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ant_design_vue_dist_antd_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_axios__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_observe_visibility__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex_router_sync__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuex_router_sync__);




var createApp = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    var router, store, app;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            router = Object(__WEBPACK_IMPORTED_MODULE_10__router__["a" /* createRouter */])({
              STORAGE_TOKEN_ID: "de.cdtm.contacts.api_token"
            });
            store = Object(__WEBPACK_IMPORTED_MODULE_11__store__["a" /* createStore */])({
              APPLICATION_VERSION: "1.0.13",
              STORAGE_TOKEN_ID: "de.cdtm.contacts.api_token",
              STORAGE_PERSIST_ID: "de.cdtm.contacts.state",
              CAMPUS_API_HOST: "https://campus.cdtm.de",
              CAMPUS_API_KEY: "3fR7nu9CnVCeBw6Fuoc6JGcomoBH5tqfUh4Wn7ICxxzDWhyrrTq0ZvizWgdj"
            }, __WEBPACK_IMPORTED_MODULE_7_axios___default.a);


            Object(__WEBPACK_IMPORTED_MODULE_12_vuex_router_sync__["sync"])(store, router);

            _context.next = 5;
            return store.dispatch('init');

          case 5:
            app = new __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
              router: router,
              store: store,
              components: { App: __WEBPACK_IMPORTED_MODULE_4__App_vue__["a" /* default */] },
              template: '<App/>'
            }, __WEBPACK_IMPORTED_MODULE_4__App_vue__["a" /* default */]));
            return _context.abrupt('return', {
              app: app,
              router: router,
              store: store
            });

          case 7:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function createApp() {
    return _ref.apply(this, arguments);
  };
}();

// now create the app















__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_7_axios___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_observe_visibility__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_ant_design_vue__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].config.productionTip = false;

createApp({
  ssr: false
}).then(function (_ref2) {
  var app = _ref2.app,
      store = _ref2.store;

  // Restore the Vuex store state
  // if send by the server
  if (window.__INITIAL_STATE__) {
    store.replaceState(window.__INITIAL_STATE__);
  }

  // Mount the app into the page
  app.$mount('#app');
});

/***/ }),

/***/ 562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(223);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b7032ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(565);
function injectStyle (ssrContext) {
  __webpack_require__(563)
}
var normalizeComponent = __webpack_require__(32)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b7032ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 563:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 565:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.initialized),expression:"initialized"}]})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 705:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 268,
	"./af.js": 268,
	"./ar": 269,
	"./ar-dz": 270,
	"./ar-dz.js": 270,
	"./ar-kw": 271,
	"./ar-kw.js": 271,
	"./ar-ly": 272,
	"./ar-ly.js": 272,
	"./ar-ma": 273,
	"./ar-ma.js": 273,
	"./ar-sa": 274,
	"./ar-sa.js": 274,
	"./ar-tn": 275,
	"./ar-tn.js": 275,
	"./ar.js": 269,
	"./az": 276,
	"./az.js": 276,
	"./be": 277,
	"./be.js": 277,
	"./bg": 278,
	"./bg.js": 278,
	"./bm": 279,
	"./bm.js": 279,
	"./bn": 280,
	"./bn.js": 280,
	"./bo": 281,
	"./bo.js": 281,
	"./br": 282,
	"./br.js": 282,
	"./bs": 283,
	"./bs.js": 283,
	"./ca": 284,
	"./ca.js": 284,
	"./cs": 285,
	"./cs.js": 285,
	"./cv": 286,
	"./cv.js": 286,
	"./cy": 287,
	"./cy.js": 287,
	"./da": 288,
	"./da.js": 288,
	"./de": 289,
	"./de-at": 290,
	"./de-at.js": 290,
	"./de-ch": 291,
	"./de-ch.js": 291,
	"./de.js": 289,
	"./dv": 292,
	"./dv.js": 292,
	"./el": 293,
	"./el.js": 293,
	"./en-SG": 294,
	"./en-SG.js": 294,
	"./en-au": 295,
	"./en-au.js": 295,
	"./en-ca": 296,
	"./en-ca.js": 296,
	"./en-gb": 297,
	"./en-gb.js": 297,
	"./en-ie": 298,
	"./en-ie.js": 298,
	"./en-il": 299,
	"./en-il.js": 299,
	"./en-nz": 300,
	"./en-nz.js": 300,
	"./eo": 301,
	"./eo.js": 301,
	"./es": 302,
	"./es-do": 303,
	"./es-do.js": 303,
	"./es-us": 304,
	"./es-us.js": 304,
	"./es.js": 302,
	"./et": 305,
	"./et.js": 305,
	"./eu": 306,
	"./eu.js": 306,
	"./fa": 307,
	"./fa.js": 307,
	"./fi": 308,
	"./fi.js": 308,
	"./fo": 309,
	"./fo.js": 309,
	"./fr": 310,
	"./fr-ca": 311,
	"./fr-ca.js": 311,
	"./fr-ch": 312,
	"./fr-ch.js": 312,
	"./fr.js": 310,
	"./fy": 313,
	"./fy.js": 313,
	"./ga": 314,
	"./ga.js": 314,
	"./gd": 315,
	"./gd.js": 315,
	"./gl": 316,
	"./gl.js": 316,
	"./gom-latn": 317,
	"./gom-latn.js": 317,
	"./gu": 318,
	"./gu.js": 318,
	"./he": 319,
	"./he.js": 319,
	"./hi": 320,
	"./hi.js": 320,
	"./hr": 321,
	"./hr.js": 321,
	"./hu": 322,
	"./hu.js": 322,
	"./hy-am": 323,
	"./hy-am.js": 323,
	"./id": 324,
	"./id.js": 324,
	"./is": 325,
	"./is.js": 325,
	"./it": 326,
	"./it-ch": 327,
	"./it-ch.js": 327,
	"./it.js": 326,
	"./ja": 328,
	"./ja.js": 328,
	"./jv": 329,
	"./jv.js": 329,
	"./ka": 330,
	"./ka.js": 330,
	"./kk": 331,
	"./kk.js": 331,
	"./km": 332,
	"./km.js": 332,
	"./kn": 333,
	"./kn.js": 333,
	"./ko": 334,
	"./ko.js": 334,
	"./ku": 335,
	"./ku.js": 335,
	"./ky": 336,
	"./ky.js": 336,
	"./lb": 337,
	"./lb.js": 337,
	"./lo": 338,
	"./lo.js": 338,
	"./lt": 339,
	"./lt.js": 339,
	"./lv": 340,
	"./lv.js": 340,
	"./me": 341,
	"./me.js": 341,
	"./mi": 342,
	"./mi.js": 342,
	"./mk": 343,
	"./mk.js": 343,
	"./ml": 344,
	"./ml.js": 344,
	"./mn": 345,
	"./mn.js": 345,
	"./mr": 346,
	"./mr.js": 346,
	"./ms": 347,
	"./ms-my": 348,
	"./ms-my.js": 348,
	"./ms.js": 347,
	"./mt": 349,
	"./mt.js": 349,
	"./my": 350,
	"./my.js": 350,
	"./nb": 351,
	"./nb.js": 351,
	"./ne": 352,
	"./ne.js": 352,
	"./nl": 353,
	"./nl-be": 354,
	"./nl-be.js": 354,
	"./nl.js": 353,
	"./nn": 355,
	"./nn.js": 355,
	"./pa-in": 356,
	"./pa-in.js": 356,
	"./pl": 357,
	"./pl.js": 357,
	"./pt": 358,
	"./pt-br": 359,
	"./pt-br.js": 359,
	"./pt.js": 358,
	"./ro": 360,
	"./ro.js": 360,
	"./ru": 361,
	"./ru.js": 361,
	"./sd": 362,
	"./sd.js": 362,
	"./se": 363,
	"./se.js": 363,
	"./si": 364,
	"./si.js": 364,
	"./sk": 365,
	"./sk.js": 365,
	"./sl": 366,
	"./sl.js": 366,
	"./sq": 367,
	"./sq.js": 367,
	"./sr": 368,
	"./sr-cyrl": 369,
	"./sr-cyrl.js": 369,
	"./sr.js": 368,
	"./ss": 370,
	"./ss.js": 370,
	"./sv": 371,
	"./sv.js": 371,
	"./sw": 372,
	"./sw.js": 372,
	"./ta": 373,
	"./ta.js": 373,
	"./te": 374,
	"./te.js": 374,
	"./tet": 375,
	"./tet.js": 375,
	"./tg": 376,
	"./tg.js": 376,
	"./th": 377,
	"./th.js": 377,
	"./tl-ph": 378,
	"./tl-ph.js": 378,
	"./tlh": 379,
	"./tlh.js": 379,
	"./tr": 380,
	"./tr.js": 380,
	"./tzl": 381,
	"./tzl.js": 381,
	"./tzm": 382,
	"./tzm-latn": 383,
	"./tzm-latn.js": 383,
	"./tzm.js": 382,
	"./ug-cn": 384,
	"./ug-cn.js": 384,
	"./uk": 385,
	"./uk.js": 385,
	"./ur": 386,
	"./ur.js": 386,
	"./uz": 387,
	"./uz-latn": 388,
	"./uz-latn.js": 388,
	"./uz.js": 387,
	"./vi": 389,
	"./vi.js": 389,
	"./x-pseudo": 390,
	"./x-pseudo.js": 390,
	"./yo": 391,
	"./yo.js": 391,
	"./zh-cn": 392,
	"./zh-cn.js": 392,
	"./zh-hk": 393,
	"./zh-hk.js": 393,
	"./zh-tw": 394,
	"./zh-tw.js": 394
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 705;

/***/ }),

/***/ 997:
/***/ (function(module, exports) {

module.exports = {"_args":[["ant-design-vue@1.3.13","/opt/build/repo/contacts-pwa"]],"_from":"ant-design-vue@1.3.13","_id":"ant-design-vue@1.3.13","_inBundle":false,"_integrity":"sha512-PMPoVcnM5Ygn8CqdCmlPK9w4i/LdxwDkZ72knPMZ1hrHUcHfWoKxZG6NW2XxxyR0vnXheEAa/4ojNaQkEAbSrQ==","_location":"/ant-design-vue","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"ant-design-vue@1.3.13","name":"ant-design-vue","escapedName":"ant-design-vue","rawSpec":"1.3.13","saveSpec":null,"fetchSpec":"1.3.13"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/ant-design-vue/-/ant-design-vue-1.3.13.tgz","_spec":"1.3.13","_where":"/opt/build/repo/contacts-pwa","bugs":{"url":"https://github.com/vueComponent/ant-design-vue/issues"},"dependencies":{"@ant-design/icons":"^2.1.1","@ant-design/icons-vue":"^2.0.0","add-dom-event-listener":"^1.0.2","array-tree-filter":"^2.1.0","async-validator":"^1.8.2","babel-helper-vue-jsx-merge-props":"^2.0.3","babel-runtime":"6.x","classnames":"^2.2.5","component-classes":"^1.2.6","dom-align":"^1.7.0","dom-closest":"^0.2.0","dom-scroll-into-view":"^1.2.1","enquire.js":"^2.1.6","intersperse":"^1.0.0","is-negative-zero":"^2.0.0","ismobilejs":"^0.5.1","json2mq":"^0.2.0","lodash":"^4.17.5","moment":"^2.21.0","mutationobserver-shim":"^0.3.2","omit.js":"^1.0.0","raf":"^3.4.0","resize-observer-polyfill":"^1.5.1","shallow-equal":"^1.0.0","shallowequal":"^1.0.2","vue-ref":"^1.0.4","warning":"^3.0.0"},"description":"An enterprise-class UI design language and Vue-based implementation","devDependencies":{"@commitlint/cli":"^6.2.0","@commitlint/config-conventional":"^6.1.3","@octokit/rest":"^15.4.1","@vue/cli-plugin-eslint":"^3.0.5","@vue/server-test-utils":"1.0.0-beta.16","@vue/test-utils":"1.0.0-beta.16","acorn":"^6.0.5","autoprefixer":"^9.6.0","axios":"^0.18.0","babel-cli":"^6.26.0","babel-core":"^6.26.0","babel-eslint":"^10.0.1","babel-helper-vue-jsx-merge-props":"^2.0.3","babel-jest":"^23.6.0","babel-loader":"^7.1.2","babel-plugin-import":"^1.1.1","babel-plugin-inline-import-data-uri":"^1.0.1","babel-plugin-istanbul":"^4.1.1","babel-plugin-syntax-dynamic-import":"^6.18.0","babel-plugin-syntax-jsx":"^6.18.0","babel-plugin-transform-class-properties":"^6.24.1","babel-plugin-transform-decorators":"^6.24.1","babel-plugin-transform-decorators-legacy":"^1.3.4","babel-plugin-transform-es3-member-expression-literals":"^6.22.0","babel-plugin-transform-es3-property-literals":"^6.22.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-object-rest-spread":"^6.26.0","babel-plugin-transform-runtime":"~6.23.0","babel-plugin-transform-vue-jsx":"^3.7.0","babel-polyfill":"^6.26.0","babel-preset-env":"^1.6.1","case-sensitive-paths-webpack-plugin":"^2.1.2","chalk":"^2.3.2","cheerio":"^1.0.0-rc.2","codecov":"^3.0.0","colorful":"^2.1.0","commander":"^2.15.0","compare-versions":"^3.3.0","cross-env":"^5.1.4","css-loader":"^0.28.7","deep-assign":"^2.0.0","enquire-js":"^0.2.1","eslint":"^5.8.0","eslint-config-prettier":"^3.0.1","eslint-plugin-html":"^3.2.2","eslint-plugin-vue":"^5.1.0","fetch-jsonp":"^1.1.3","fs-extra":"^7.0.0","glob":"^7.1.2","gulp":"^4.0.1","gulp-babel":"^7.0.0","gulp-strip-code":"^0.1.4","highlight.js":"^9.12.0","html-webpack-plugin":"^3.2.0","husky":"^0.14.3","istanbul-instrumenter-loader":"^3.0.0","jest":"^24.0.0","jest-serializer-vue":"^1.0.0","js-base64":"^2.4.8","jsonp":"^0.2.1","less":"^3.9.0","less-loader":"^4.1.0","less-plugin-npm-import":"^2.1.0","lint-staged":"^7.2.2","markdown-it":"^8.4.0","markdown-it-anchor":"^4.0.0","marked":"^0.3.7","merge2":"^1.2.1","mini-css-extract-plugin":"^0.5.0","minimist":"^1.2.0","mkdirp":"^0.5.1","mockdate":"^2.0.2","node-emoji":"^1.10.0","nprogress":"^0.2.0","optimize-css-assets-webpack-plugin":"^5.0.1","postcss":"^7.0.6","postcss-loader":"^3.0.0","pre-commit":"^1.2.2","prettier":"^1.15.3","querystring":"^0.2.0","raw-loader":"^1.0.0-beta.0","reqwest":"^2.0.5","rimraf":"^2.6.2","rucksack-css":"^1.0.2","selenium-server":"^3.0.1","semver":"^5.3.0","style-loader":"^0.18.2","stylelint":"^9.10.1","stylelint-config-prettier":"^4.0.0","stylelint-config-standard":"^18.2.0","through2":"^2.0.3","uglifyjs-webpack-plugin":"^2.1.1","url-loader":"^1.1.2","vue":"^2.5.16","vue-antd-md-loader":"^1.1.0","vue-clipboard2":"0.0.8","vue-eslint-parser":"^5.0.0","vue-i18n":"^8.3.2","vue-infinite-scroll":"^2.0.2","vue-jest":"^2.5.0","vue-loader":"^15.5.1","vue-router":"^3.0.1","vue-server-renderer":"^2.5.16","vue-template-compiler":"^2.5.16","vue-virtual-scroller":"^0.12.0","vuex":"^3.1.0","webpack":"^4.28.4","webpack-cli":"^3.2.1","webpack-dev-server":"^3.1.14","webpack-merge":"^4.1.1","webpackbar":"^3.1.5"},"files":["dist","lib","es","types","scripts"],"homepage":"https://vue.ant.design/","keywords":["ant","design","antd","vue","vueComponent","component","components","ui","framework","frontend"],"license":"MIT","main":"lib/index.js","module":"es/index.js","name":"ant-design-vue","peerDependencies":{"vue":">=2.5.0","vue-template-compiler":">=2.5.0"},"pre-commit":["lint","prettier"],"repository":{"type":"git","url":"git+https://github.com/vueComponent/ant-design-vue.git"},"scripts":{"codecov":"codecov","commitmsg":"commitlint -x @commitlint/config-conventional -e $GIT_PARAMS","compile":"node antd-tools/cli/run.js compile","copy":"node scripts/run.js copy-html","dev":"cross-env NODE_ENV=development ENTRY_INDEX=dev ./node_modules/.bin/webpack-dev-server --open --hot --port 3001","dist":"node antd-tools/cli/run.js dist","lint":"eslint -c ./.eslintrc --fix --ext .jsx,.js,.vue ./components","lint:style":"stylelint \"{site,components}/**/*.less\" --syntax less","postinstall":"node scripts/postinstall || echo \"ignore\"","pre-publish":"node ./scripts/prepub","prepublish":"node antd-tools/cli/run.js guard","prettier":"node ./scripts/prettier.js","pub":"node antd-tools/cli/run.js pub","pub-with-ci":"node antd-tools/cli/run.js pub-with-ci","site":"node scripts/run.js _site","start":"cross-env NODE_ENV=development ./node_modules/.bin/webpack-dev-server --open --hot","test":"cross-env NODE_ENV=test jest --config .jest.js"},"sideEffects":["site/*","components/style.js","components/**/style/*","*.vue","*.md","dist/*","es/**/style/*","lib/**/style/*","*.less"],"title":"Ant Design Vue","typings":"types/index.d.ts","version":"1.3.13"}

/***/ })

},[533]);


// WEBPACK FOOTER //
// static/js/app.5e19b5fbe830e4c9c5d0.js